// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgMinimizeIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M7.013 19.998h-2c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.65 1.35 3 3 3h2c.55 0 1-.45 1-1s-.45-1-1-1M17.013 3.998h2c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-1.65-1.35-3-3-3h-2c-.55 0-1 .45-1 1s.45 1 1 1M22.68 21.107 2.895 1.319a1.11 1.11 0 0 0-1.56 0 1.11 1.11 0 0 0 0 1.561l1.11 1.11c-.21.44-.33.913-.33 1.419v2.198c0 .605.494 1.1 1.099 1.1.604 0 1.099-.495 1.099-1.1V5.86L18.152 19.7h-1.748c-.605 0-1.1.495-1.1 1.1s.495 1.1 1.1 1.1h2.198c.495 0 .979-.122 1.418-.33l1.11 1.11c.22.22.495.319.78.319a1.095 1.095 0 0 0 .78-1.869z" />
  </g>
);
export default SvgMinimizeIcon;
SvgMinimizeIcon.displayName = 'SvgMinimizeIcon';
